import { RIGHT_ARROW } from "../lib/assets";
export const FEATURE_TWO_LIST = [
  {
    id: 1,
    icon: "flaticon-family", // Puedes cambiar el ícono si tienes otro en mente
    title: "Seguros para personas",
    subtitle: "Protección personalizada para ti y tu familia: Seguros de Vida, Salud, Educación, Accidentes y Pensión.",
  },
  {
    id: 2,
    icon: "flaticon-investment", // Ícono sugerido, puedes ajustarlo según tu librería
    title: "Seguros Empresariales",
    subtitle: "Soluciones integrales para proteger tu patrimonio: Seguros de Automóviles, Responsabilidad Civil, e Ingeniería.",
  },
  {
    id: 3,
    icon: "flaticon-taxes", // Ícono sugerido
    title: "Seguros de Cumplimiento",
    subtitle: "Garantizamos el cumplimiento de tus obligaciones contractuales y legales con respaldo y total seguridad.",
  },
];

export const FEATURE_THREE_LIST = [
  {
    id: 1,
    title: "Finance Planning",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
  {
    id: 2,
    title: "Business Consulting",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
  {
    id: 3,
    title: "Tax Advisory",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
  {
    id: 4,
    title: "Business Audit",
    subtitle:
      "Morem Ipsum Dolor Sittemet Consectetur Adipiscing Elitflorai Psum Dolor.",
    href: "/services-details",
    src: RIGHT_ARROW,
  },
];

export const FEATURE_FOUR_LIST = [
  {
    id: 1,
    icon: "flaticon-life-insurance",
    title: "More coverage",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 2,
    icon: "flaticon-handshake",
    title: "Less hassle",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 3,
    icon: "flaticon-money",
    title: "Faster benefits",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
];

export const FEATURE_ONE_LIST = [
  {
    id: 1,
    icon: "flaticon-folder", // Puedes cambiar el ícono si tienes otro en mente
    title: "Asesoría Personalizada",
    subtitle: "Acompañamiento experto en cada etapa del proceso, desde la cotización hasta la reclamación.",
  },
  {
    id: 2,
    icon: "flaticon-inspiration", // Ícono sugerido, puedes ajustarlo según tu librería
    title: "Soluciones a la Medida",
    subtitle: "Diseñamos planes de seguros según tu perfil personal o empresarial, sin coberturas innecesarias.",
  },
  {
    id: 3,
    icon: "flaticon-rocket", // Ícono sugerido
    title: "Crecimiento Seguro",
    subtitle: "Apoyamos a personas y empresas en su crecimiento, garantizando respaldo, estabilidad y tranquilidad.",
  },
];
